const APPLIED = '__qmAutofillDisabled';

type Patchable = (HTMLInputElement | HTMLTextAreaElement) & {
  [APPLIED]?: true;
};

function apply(el: Patchable) {
  if (el[APPLIED]) return;
  if (el.hasAttribute('autocomplete')) {
    el[APPLIED] = true;
    return;
  }
  el.setAttribute('autocomplete', 'off');
  el.setAttribute('autocorrect', 'off');
  el.setAttribute('autocapitalize', 'off');
  el.setAttribute('spellcheck', 'false');
  el.setAttribute('data-lpignore', 'true');
  el.setAttribute('data-1p-ignore', 'true');
  el.setAttribute('data-form-type', 'other');
  el[APPLIED] = true;
}

function scan(root: ParentNode) {
  root
    .querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea')
    .forEach((el) => {
      apply(el as Patchable);
    });
}

let installed = false;

export function installAutofillDisabler() {
  if (typeof document === 'undefined' || installed) return;
  installed = true;

  const start = () => {
    scan(document.body);
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.tagName === 'INPUT' || node.tagName === 'TEXTAREA') {
            apply(node as Patchable);
          } else {
            scan(node);
          }
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}
